import store from "@/store";

export const GENERIC_PAYMENT_STATUS_ERROR_MESSAGE =
  "تعذر تأكيد حالة عملية الدفع، يرجى مراجعة سجل التبرعات للتأكد من حالة العملية";
export const GENERIC_PAYMENT_STATUS_ERROR_MESSAGE_NON_LOGGED_IN_USERS =
  " .جارٍ معالجة عملية الدفع، وستصلك رسالة تأكيد عند اكتمالها. لا حاجة لإعادة التبرع";

export function extractPaymentFailureMessage(error: any): string {
  if (error?.response?.data?.errors?.length > 0) {
    return error.response.data.errors[0];
  }
  if (error?.response?.data?.message) {
    return error.response.data.message;
  }
  return store.getters.isAuthenticated
    ? GENERIC_PAYMENT_STATUS_ERROR_MESSAGE
    : GENERIC_PAYMENT_STATUS_ERROR_MESSAGE_NON_LOGGED_IN_USERS;
}